import React, { useEffect, useState, useRef, useCallback } from "react";
import "./styles.scss";
import DataTable from "components/DataTable";
import { CommunityColumn } from "../data";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { getTopCommunity } from "store/slice/TransactionSlice/TransactionSlice";
import SearchIcon from "components/SearchBar";
import Dropdown from "components/Dropdown";
import Pagination from "components/Pagination";
import useSearch from "hooks/useSearch";

type Props = {};

const TopCommunities: React.FunctionComponent<Props> = () => {
  //State
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);

  //Hook
  const { search, inputRef, handleChange, searched } = useSearch(getTopCommunity, perPage);

  //Redux
  const dispatch = useDispatch();
  const transaction = useSelector((state: RootState) => state.transaction);

  useEffect(() => {
    dispatch(getTopCommunity(page, perPage));
  }, []);

  // setpage number to 1 if searched is done
  useEffect(() => {
    if (searched) setPage(1);
  }, [searched]);

  //------------------------------------------------------------
  //Show Number for PerPage Function
  //------------------------------------------------------------
  const handleNewPage = useCallback(
    (pageNo: number, page = 1) => {
      setPerPage(pageNo);
      setPage(1);
      dispatch(getTopCommunity(page, pageNo, search));
    },
    [search]
  );
  //--------------------------------------------
  //Pagination
  //---------------------------------------------
  const handlePageChange = useCallback(
    (page: number, perPage: number) => {
      setPage(page);
      dispatch(getTopCommunity(page, perPage, search));
    },
    [search]
  );

  const paginate = useCallback(
    (pageNo: number, perPage: number) => {
      setPage(pageNo);
      dispatch(getTopCommunity(pageNo, perPage, search));
    },
    [search]
  );

  return (
    <div className="topCommunities-page mt-4">
      <div className="container">
        <h4 className="page-title mb-2">Top 10 Communities’</h4>
        <div className="search-field">
          <SearchIcon
            placeholder="Search for Communites name, State or LGA"
            boxClasses=" mb-4"
            textRef={inputRef}
            value={search}
            onChange={handleChange}
          />
          {/* <Dropdown perPage={perPage} action={handleNewPage} /> */}
        </div>

        <DataTable columns={CommunityColumn} data={transaction?.topCommunity?.farmers} />
        {/* <Pagination
                    page={page}
                    lastPage={transaction?.topCommunity?.pagination?.lastPage}
                    paginate={paginate}
                    total={transaction?.topCommunity?.pagination?.total}
                    handlePageChange={handlePageChange}
                    perPage={perPage}
                /> */}
      </div>
    </div>
  );
};

export default TopCommunities;
